module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_rehoboth.335b0f4e416c2ee2cbc1016c100dcd98.png";